import { prependCdnResourcesUrl } from "@/utils/network";

export type Review = {
    content: string;
    image: string;
    name: string;
};

export const REVIEWS: Review[] = [
    {
        content:
            "They provided me with a great contractor who is fully insured, gave me great rates, and did the job on time and complete. Highly satisfied with the service provided by the contractor they chose for me.",
        image: prependCdnResourcesUrl("/images/networx/homepage/reviews-section/art-r.webp"),
        name: "Art R.",
    },
    {
        content:
            "He was very prompt compared to other contractors. He provided a very fair and comprehensive estimate for my fence and warned me against low grade products. Available to start within days rather than weeks.",
        image: prependCdnResourcesUrl("/images/networx/homepage/reviews-section/anita-c.webp"),
        name: "Anita C.",
    },
    {
        content:
            "I contacted them in the evening, and got contacted by the repairman quickly. We hired him and are very pleased. In my opinion Networx is easier to use than any of the other businesses who do the same service. Will recommend and use them again.",
        image: prependCdnResourcesUrl("/images/networx/homepage/reviews-section/rodger-p.webp"),
        name: "Rodger P.",
    },
    {
        content:
            "I put in what I needed done and got several calls soon after. I picked a contractor and had the work done quickly. They kept in touch to make sure everything was working out for me. Being new to the area I was unsure who was reputable and this gave me confidence in hiring.",
        image: prependCdnResourcesUrl("/images/networx/homepage/reviews-section/wendy-t.webp"),
        name: "Wendy T.",
    },
    {
        content:
            "Prompt service. Excellent quality work. Very fair in pricing. Very professional and knowledgeable. You'll be very happy with their work. Great service. Very happy with my finished driveway.",
        image: prependCdnResourcesUrl("/images/networx/homepage/reviews-section/susan-b.webp"),
        name: "Susan B.",
    },
];
